import { render, staticRenderFns } from "./RemoveGoalSetDialog.vue?vue&type=template&id=93bced80"
import script from "./RemoveGoalSetDialog.ts?vue&type=script&lang=ts&external"
export * from "./RemoveGoalSetDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./RemoveGoalSetDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports